(() => {
  'use strict';

  // Vitals mounts asynchronously. Use its real radio action so its quantity,
  // prices and selected styling update together; never just paint a selection.
  const widgetSelector = '.vtl-ub-vd-widget';
  const formSelector = 'form.Vtl-NewVolumeDiscountRadio';
  const radioSelector = '[data-vtl-el="tier-label"][role="radio"]';
  const touchedOffers = new Set();
  const touchedQuantities = new Set();
  const attempts = new WeakMap();
  let queued = false;

  const offerKey = (widget) => `${location.pathname}:${widget.dataset.trackEdOid || ''}`;

  function rememberCustomerChoice(event) {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    if (event.type === 'keydown' && ![' ', 'Enter', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    const radio = event.target.closest(radioSelector);
    const widget = radio?.closest(widgetSelector);
    if (widget) touchedOffers.add(offerKey(widget));
    if (event.target.closest('product-form-component quantity-selector')) {
      touchedQuantities.add(location.pathname);
    }
  }

  function applyDefaults() {
    queued = false;
    if (touchedQuantities.has(location.pathname)) return;
    document.querySelectorAll(`${widgetSelector} ${formSelector}`).forEach((form) => {
      if (form.closest('dialog, quick-add-dialog, product-card')) return;
      const widget = form.closest(widgetSelector);
      if (!widget || touchedOffers.has(offerKey(widget))) return;
      const single = Array.from(form.querySelectorAll(radioSelector)).find((radio) => {
        const title = radio.querySelector('[data-vtl-el="title"]')?.textContent || '';
        return title.normalize('NFKC').replace(/\s+/g, '') === '1個';
      });
      if (!single || single.getAttribute('aria-disabled') === 'true' || single.getAttribute('aria-checked') === 'true') return;
      const count = attempts.get(single) || 0;
      if (count >= 3) return;
      attempts.set(single, count + 1);
      single.click();
      // Bounded retries cover a widget whose markup precedes its event binding.
      if (single.getAttribute('aria-checked') !== 'true') setTimeout(schedule, 200);
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(applyDefaults);
  }

  ['pointerdown', 'click', 'keydown', 'change'].forEach((type) => {
    document.addEventListener(type, rememberCustomerChoice, true);
  });

  const observer = new MutationObserver((records) => {
    const relevant = records.some((record) => {
      if (record.target instanceof Element && record.target.closest(widgetSelector)) return true;
      return Array.from(record.addedNodes).some((node) => node instanceof Element &&
        (node.matches(widgetSelector) || node.querySelector(widgetSelector)));
    });
    if (relevant) schedule();
  });
  observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-checked'] });
  schedule();
})();
